export enum TabsType {
    default = 'default',
    profileNavigation = 'profile-navigation',
    subNavigation = 'sub-navigation',
    pickXNavigation = 'pick-x-navigation',
    statistics = 'statistics',
    lobby = 'lobby',
    skywardDeluxeNavigation = 'skywardDeluxeNavigation',
}
